import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { requestResetStats, requestSurrender, forceUpdate, showLeaderboards, OVER_RESTART, SHOW_LEADERS } from '../../HOME/REDUX/actions';
import { delay, playSound, windowSize, dbget, dbset, dbdel } from '../../HOME/utils';
import { SECS_PER_LEVEL, MSECS_PER_ITEM, MSECS_PER_ITEM_INCREASE, MSECS_TICK } from '../const';
import * as f from '../logic';
import { setOver, updateStats } from '../REDUX/actions';
import { setLevel, setStack, pause, removeNumber, setSelected, setSecs, setScore, setPoints, setPointsVisible, setInit } from '../REDUX/actions';
import '../styles.css';
import MessageBox from '../../HOME/COMPONENTS/MessageBox';
import NumPad from './NumPad';
import StackItem from './StackItem';
import { levelInfo } from './NumPad';
import { useSpring, animated } from 'react-spring';
import XIcon from '../../HOME/SVG/XIcon';
import { useInterval } from '../../HOME/utils';
import GameOverOptions from '../../HOME/COMPONENTS/GameOverOptions';

const Board = props => {
  const l = useRef({});
  const { forceUpdate, setLevel, setStack, setSelected, pause, setSecs } = props;
  const { removeNumber, setScore, setOver, setPoints, setPointsVisible, practice } = props;
  let { requestResetStats, requestSurrender, showLeaderboards } = props;
  let { secs, level, score, stack } = props;
  level = level || 0;
  stack = stack || [];
  const stackCapacity = 14 - (level || 1);

  useEffect(() => {
    const onResize = () => {
      l.current.rect = null;
      forceUpdate();
    };

    window.addEventListener('resize', onResize);

    load();

    return () => {
      window.removeEventListener('resize', onResize);
      requestResetStats(false);
      requestSurrender(false);
    };
  }, []);

  const load = () => {
    if (practice) {
      doInit(1);
      return;
    }

    dbget(f.boardKey(props), json => {
      if (!json) {
        doInit(1);
        return;
      }

      const { level, secs, stack, score } = fromJson(json);

      pause(true);
      setStack(stack);
      setSelected([]);
      setSecs(secs);
      setLevel(level);
      setScore(score);
      removeNumber(0);
    });
  };

  const doInit = level => {
    playSound(props, 'dice');

    setOver(false);
    pause(true);
    setStack([]);
    setSelected([]);
    setSecs(SECS_PER_LEVEL);
    removeNumber(0);

    if (level === 1) {
      setScore(0);
    }

    if (level <= 8) {
      setLevel(level);
    }

    if (!practice) {
      const json = JSON.stringify({ level, secs: SECS_PER_LEVEL, stack: [], score });
      save(json);
    }
  };

  const save = json => {
    dbset(f.boardKey(), json || toJson());
  };

  const toJson = () => {
    const json = JSON.stringify({ level, secs, stack, score });
    return json;
  };

  const fromJson = json => {
    return JSON.parse(json);
  };

  const rect = l.current.rect;

  let cellHeight = 40;
  let itemHeight = 0;

  if (!rect) {
    Promise.resolve().then(forceUpdate);
  } else {
    const h = rect.height - 27;

    while (cellHeight >= 30) {
      itemHeight = (h - level * cellHeight) / stackCapacity;

      if (itemHeight >= 28) {
        break;
      }

      --cellHeight;
    }
  }

  const onTick = () => {
    let stackSize = stack.length;

    if (stackSize > 1 && stack[stackSize - 2] === props.numberToRemove) {
      --stackSize;
    }

    const maxDrop = (stackCapacity - stackSize) * itemHeight;
    l.current.drop += itemHeight / ((MSECS_PER_ITEM * (practice ? 2 : 1) + MSECS_PER_ITEM_INCREASE * (level - 1)) / MSECS_TICK);
    l.current.drop = Math.min(l.current.drop, maxDrop);

    forceUpdate();

    if (!(l.current.drop < maxDrop) && props.stack && props.stack[props.stack.length - 1] !== props.numberToRemove) {
      pushItem();
    }
  };

  useInterval(onTick, props.paused ? null : MSECS_TICK);

  const onOver = () => {
    playSound(props, 'won');

    pause(true);
    setOver(true);
    setStack([]);
    setSelected([]);

    if (!practice) {
      setStats();
    }
  };

  const setStats = () => {
    dbdel(f.boardKey());

    const { score } = props;
    let { plays, aggScore, bestScore } = props.stats || {};
    plays = (plays || 0) + 1;
    aggScore = (aggScore || 0) + score;

    bestScore = Math.max(score, bestScore || 0);

    const key = f.statsKey(props);
    const stats = { plays, aggScore, bestScore };

    dbset(key, stats);
    props.updateStats(stats);
  };

  const onCountdown = () => {
    const { secs } = props;

    setSecs(secs - 1);

    if (secs - 1 <= 0) {
      if (secs === 0) {
        // alert(secs);
      }

      if (level < 8) {
        props.setInit(level + 1);
      } else {
        onOver();
      }

      return;
    }

    const json = JSON.stringify({ level, secs: secs - 1, stack, score });
    save(json);
  };

  useInterval(onCountdown, props.paused || practice ? null : 1000);

  const pushItem = () => {
    if (stack.length === stackCapacity) {
      onOver();
      return;
    }

    playSound(props, 'click');

    const maxNum = levelInfo(level).max;

    while (true) {
      const num = _.random(1, maxNum);

      if (!_.find(stack, n => n === num) && num !== props.numberToRemove) {
        stack.push(num);
        break;
      }
    }

    setStack(stack);

    l.current.drop = 0;
    pause(false);
  };

  const { transform } = useSpring({
    transform: `rotateY(${props.init ? 90 : 0}deg)`,
    config: { duration: 500 },
    onRest: () => {
      if (props.init) {
        doInit(props.init);
        props.setInit(0);
      }
    },
  });

  const handleStart = () => {
    if (props.over) {
      props.setInit(practice ? props.level : 1);
    } else {
      pushItem();
    }
  };

  const promptSpring = useSpring({
    opacity: `${props.paused ? 1 : 0}`,
  });

  let { x, y } = windowSize();
  y -= 200;
  let width = Math.min(x, y) * 0.9;
  width = Math.min(width, 321);

  const handleConfirmSurrender = yes => {
    delay(() => {
      props.requestSurrender(false);

      if (!yes) {
        return;
      }

      if (!practice) {
        setStats();
      }

      props.setInit(practice ? level : 1);
    });
  };

  const handleConfirmResetStats = yes => {
    if (yes) {
      props.updateStats();
    }

    delay(() => props.requestResetStats(false));
  };

  const pointsSpring = useSpring({
    opacity: props.points && props.pointsVisible ? 1 : 0,
    onRest: () => {
      if (props.points) {
        if (props.pointsVisible) {
          setPointsVisible(false);
        } else {
          setPoints(0);
        }
      }
    },
  });

  const handleUnselectAll = () => {
    playSound(props, 'link1');
    setSelected([]);
  };

  const handleOverResponse = op => {
    if (op === SHOW_LEADERS) {
      showLeaderboards();
    } else if (op === OVER_RESTART) {
      handleStart();
    }
  };

  const renderOverPrompt = () => {
    return props.over ? (
      <GameOverOptions header={practice ? '' : 'Game Over'} againOnly={practice} handleResponse={handleOverResponse} />
    ) : (
      <animated.div className="nm-start-prompt" style={{ opacity: promptSpring.opacity }}>
        <span>{`LEVEL ${level}`}</span>
        <div className="ms-start" onClick={handleStart}>
          {secs < SECS_PER_LEVEL ? 'RESUME' : 'START'}
        </div>
      </animated.div>
    );
  };

  return (
    <animated.div
      className="nm-board-container"
      style={{ transform }}
      ref={e => {
        l.current.rect = e ? e.getBoundingClientRect() : null;
      }}>
      <div className="nm-stack">
        {itemHeight &&
          !props.paused &&
          _.map(stack, (n, i) => {
            return <StackItem key={i} index={i} height={itemHeight} number={n} pushItem={pushItem} drop={l.current.drop} />;
          })}
      </div>
      <animated.div className="nm-points" style={{ opacity: pointsSpring.opacity }}>
        +{props.points}
      </animated.div>
      <span className={`toolbar-button nm-x ${(props.selected || []).length ? '' : 'toolbar-button-disabled'}`} onClick={handleUnselectAll}>
        <XIcon width="36" color="pink" />
      </span>
      {props.paused && !props.surrender && !props.resetStats && renderOverPrompt()}
      <div style={{ gridArea: '2/1' }}>
        <NumPad level={level} cellHeight={cellHeight} itemHeight={itemHeight} />
      </div>
      {props.surrender && <MessageBox message="Start over?" yesNo width={width} onReply={handleConfirmSurrender} />}
      {props.resetStats && <MessageBox message="Reset stats?" yesNo width={width} onReply={handleConfirmResetStats} />}
    </animated.div>
  );
};

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  {
    forceUpdate,
    setLevel,
    setStack,
    pause,
    removeNumber,
    setSelected,
    setSecs,
    setScore,
    setOver,
    updateStats,
    requestSurrender,
    requestResetStats,
    setPoints,
    setPointsVisible,
    setInit,
    showLeaderboards,
  }
)(Board);
